/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { UserVo } from '@/vo/user';
import { ProfileFieldEnum } from './types';

// const FormCompanyMessage = '请填写正确的公司名称(不少于5个汉字)';
/** 自营渠道id */
export const SelfCommodityId = '8180';

/** 配偶联系人字段 */
export const ContactSpouseFields = [
  ProfileFieldEnum.CONTACT_NAME,
  ProfileFieldEnum.CONTACT_PHONE,
  ProfileFieldEnum.CONTACT_RELATION,
];
/** 通用固定字段(授信、提现) */
export const CommonFixedFields = [
  ProfileFieldEnum.EDUCATION_DEGREE,
  ProfileFieldEnum.PRE_TAX_MONTH_SALARY,
  ProfileFieldEnum.LIVE_ADDRESS,
  ProfileFieldEnum.LIVE_ADDRESS_DETAILS,
];
/** supplyNeedConfig返回的补充字段: 先排除 'id'、通用固定的字段 */
export const ExcludeDynamicSupplyField = ['id', ...CommonFixedFields];

export enum DynamicFieldEnum {
  /** 职业 */
  PROFESSION = 'profession',
  /** 所属行业 */
  INDUSTRY = 'industry',
}

/** 自营渠道自定义字段 需由用户选定“职业”后来限定“所属行业”，所以让“职业”前置，可以避免填写“所属行业”后被清空的情况 */
export const makeProfessionBeforeIndustry = (dynamicArr: string[]): void => {
  const professionIndex = dynamicArr.indexOf(DynamicFieldEnum.PROFESSION);
  const industryIndex = dynamicArr.indexOf(DynamicFieldEnum.INDUSTRY);

  /** 若是同时存在这两字段，则进行位置交互 */
  if (professionIndex !== -1 && industryIndex !== -1 && professionIndex > industryIndex) {
    dynamicArr[industryIndex] = DynamicFieldEnum.PROFESSION;
    dynamicArr[professionIndex] = DynamicFieldEnum.INDUSTRY;
  }
};
